"use client";

import React, { FC } from "react";
import Heading from "@/shared/Heading";
import { useTranslation } from "react-i18next";

export interface Statistic {
  id: string;
  heading: string;
  subHeading: string;
}

export interface SectionStatisticProps {
  className?: string;
}

const SectionStatistic: FC<SectionStatisticProps> = ({ className = "" }) => {

  const { t } = useTranslation("guydeez");

  const stats: Statistic[] = [
    {
      id: "1",
      heading: "+ 1 000",
      subHeading: t('about_us_tours'),
    },
    {
      id: "2",
      heading: "+ 50 000",
      subHeading: t('about_us_bookings_per_year'),
    },
    {
      id: "3",
      heading: "+ 15 000",
      subHeading:t('about_us_local_guides'),
    },
    {
      id: "4",
      heading: "~ 300",
      subHeading: t('about_us_destinations_over_world'),
    },
  ];

  return (
    <div className={`nc-SectionStatistic relative ${className}`}>
      <Heading
        desc={t('about_us_fast_facts_desc')}
      >
        {t('about_us_fast_facts_title')}
      </Heading>
      <div className="grid md:grid-cols-2 gap-6 lg:grid-cols-4 xl:gap-8">
        {stats.map((item) => (
          <div
            key={item.id}
            className="p-6 bg-neutral-50 dark:bg-neutral-800 rounded-2xl dark:border-neutral-800"
          >
            <h3 className="text-2xl font-semibold leading-none text-neutral-900 md:text-3xl dark:text-neutral-200">
              {item.heading}
            </h3>
            <span className="block text-sm text-neutral-500 mt-3 sm:text-base dark:text-neutral-400">
              {item.subHeading}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionStatistic;
